import { IconProps } from "./";
import Icon from "./assets/select_picker_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24SelectPicker(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
